import {
	POST_OPERATION_SCHEDULE_COLABORATORS,
	POST_OPERATION_SCHEDULE_COLABORATORS_ERROR,
	POST_OPERATION_SCHEDULE_COLABORATORS_SUCCESS,
} from '../../../constants';

export const postScheduleCollaboratorReducer = (state, actions) => {
	switch (actions.type) {
		case POST_OPERATION_SCHEDULE_COLABORATORS:
			return {
				...state,
				loading: true,
				error: null,
				errorShow: false,
			};
		case POST_OPERATION_SCHEDULE_COLABORATORS_ERROR:
			return {
				...state,
				loading: false,
				error: actions.payload,
				errorShow: true,
			};
		case POST_OPERATION_SCHEDULE_COLABORATORS_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				errorShow: false,
				schedule: actions.payload,
			};
		default:
			return state;
	}
};
